import { useMemo } from "react";
import { useGetWasteManagementWasteTypes } from "../../../../../api/static-data";
import { toLabelMap, toSelectOptions } from "../../shared/utils/staticDataOptions.utils";

/** Fetches waste-management types and derives the select options + label map. */
export const useWasteManagementOptions = () => {
  const { data: wasteTypes } = useGetWasteManagementWasteTypes();

  return useMemo(
    () => ({
      mgmtOptions: toSelectOptions(wasteTypes),
      mgmtLabelMap: toLabelMap(wasteTypes)
    }),
    [wasteTypes]
  );
};
